import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TemplatesState {
    templates: Record<string, unknown>[];
    templatesLoading: boolean;
    templatesLoadingMore: boolean;
    templatesError: string | null;
    projectData: Record<string, unknown>;
    page: number;
    perPage: number;
    totalPages: number;
    totalItems: number;
    hasMore: boolean;
    searchTerm: string;
    template_id: string | null;
}

interface TemplatesPagePayload {
    templates?: Record<string, unknown>[];
    total?: number;
    pages?: number;
    page?: number;
    per_page?: number;
}

const initialState: TemplatesState = {
    templates: [],
    templatesLoading: false,
    templatesLoadingMore: false,
    templatesError: null,
    projectData: {},
    page: 1,
    perPage: 10,
    totalPages: 1,
    totalItems: 0,
    hasMore: true,
    searchTerm: '',
    template_id: null,
};

export const templatesSlice = createSlice({
    name: 'templates',
    initialState,

    reducers: {

        setTemplatesRes: (state, action: PayloadAction<TemplatesPagePayload>) => {
            state.templates = action?.payload?.templates || []
            state.totalItems = action?.payload?.total || 0
            state.totalPages = action?.payload?.pages || 1
            state.page = action?.payload?.page || 1
            state.perPage = action?.payload?.per_page || 10
            state.hasMore = state.page < state.totalPages
        },
        appendTemplatesData: (state, action: PayloadAction<TemplatesPagePayload>) => {
            state.templates = [...state.templates, ...(action?.payload?.templates || [])]
            state.totalItems = action?.payload?.total || 0
            state.totalPages = action?.payload?.pages || 1
            state.page = action?.payload?.page || 1
            state.perPage = action?.payload?.per_page || 10
            state.hasMore = state.page < state.totalPages
        },
        setTemplatesError: (state, action: PayloadAction<string | null>) => {
            state.templatesError = action.payload
        },
        setTemplatesLoading: (state, action: PayloadAction<boolean>) => {
            state.templatesLoading = action.payload
        },
        setTemplatesLoadingMore: (state, action: PayloadAction<boolean>) => {
            state.templatesLoadingMore = action.payload
        },
        setTemplateByIdRes: (state, action: PayloadAction<Record<string, unknown>>) => {
            state.projectData = action.payload
        },
        resetTemplatesPagination: (state) => {
            state.page = 1
            state.hasMore = true
        },
        setTemplatesSearchTerm: (state, action: PayloadAction<string>) => {
            state.searchTerm = action.payload
            state.page = 1
            state.hasMore = true
        },
        setTemplateId: (state, action: PayloadAction<string | null>) => {
            state.template_id = action.payload
        },
        resetTemplateId: (state) => {
            state.template_id = null
        }
    }
});

export const {
    setTemplatesRes, setTemplatesLoading, setTemplatesError,
    setTemplateByIdRes, appendTemplatesData, setTemplatesLoadingMore,
    resetTemplatesPagination, setTemplatesSearchTerm,
    setTemplateId, resetTemplateId
} = templatesSlice.actions;

export default templatesSlice.reducer;
